import { PropsWithChildren } from 'react'
import Card, { CardType } from './Card'
import { ReactFC } from 'common/types/ReactFC'
import Icon, { IconName } from 'components/Icon'
import { ColorType } from 'common/types/color-type'

type LargeIconCardType = CardType & {
  icon: IconName
  color: ColorType
  padding?: string
}

const LargeIconCard: ReactFC<PropsWithChildren<LargeIconCardType>> = ({
  children,
  color,
  icon,
  padding,
  ...rest
}) => {
  return (
    <div className='col-lg-6 mb-lg-0 mb-6'>
      <Card className='d-flex' {...rest} padding={padding || '0'}>
        <Icon
          name={icon}
          fill={color}
          width={123}
          height={123}
          className='icon-card--icon'
        />
        {children}
      </Card>
    </div>
  )
}

export default LargeIconCard
